import { IBaseUser } from 'src/app/core';
import { IMetric } from '../charts';

export interface IPatient extends IBaseUser {
  device: any; // temp
  doctorId: string;
  hasDeleteRequest: boolean;
  ivctMetrics: IMetric[];
  lvetMetrics: IMetric[];
  pepMetrics: IMetric[];
  lastSampleUpdate?: string;
  userRequests?: any; // temp
}
